/* eslint camelcase: 0 */
import _ from 'lodash';
import { TooAddressSnapshot, TooResidentialPolicySnapshot } from '../../models';
import api from '../api';
import { getBackVersion } from '../../config';

type TooResidentialPolicyResponse = Omit<
    TooResidentialPolicySnapshot,
    'addresses'
> & {
    addresses: TooAddressSnapshot[];
};

const toSnapshot = (
    response: TooResidentialPolicyResponse
): TooResidentialPolicySnapshot => {
    return {
        ...response,
        addresses: _.keyBy(response.addresses, x => x.type),
    };
};

const getTicketInsurance = (
    insuranceId: string
): Promise<TooResidentialPolicySnapshot> =>
    api
        .request<TooResidentialPolicyResponse>({
            url: `${getBackVersion()}/agent/insurances/residential/too/${insuranceId}/ticket`,
            method: 'GET',
        })
        .then(toSnapshot);

const getExternalTicketInsurance = (
    insuranceId: string,
    accessToken: string
): Promise<TooResidentialPolicySnapshot> =>
    api
        .request<TooResidentialPolicyResponse>({
            url: `${getBackVersion()}/insurances/residential/${insuranceId}`,
            method: 'GET',
            action: 'GUEST_LOGIN',
            params: { access_token: accessToken },
        })
        .then(toSnapshot);

export { getTicketInsurance, getExternalTicketInsurance };
